/**
 * 提示组件背景
 */
import React, { useState } from "react"
import ReactDOM from "react-dom"
import "./index.less"

export function StockLayer(props: { onClose: Function }) {
  const close = () => {
    props.onClose()
  }
  return <div className="stock-layer" onClick={close}></div>
}

export function ZXLayer() {
  return <div className="zx-layer"></div>
}

export function PopMask(props: { onClose: Function }) {
  const close = () => {
    props.onClose()
  }
  return ReactDOM.createPortal(<div className="pop-mask" onClick={close}></div>,document.body)
}

export function PkTipsMask(props: { onClose: Function }) {
  const close = () => {
    props.onClose()
  }
  return ReactDOM.createPortal(<div className="pk-tips-mask" onClick={close}></div>,document.body)
}

export function PanKouTips() {
  return (
    <div className="pk-tips">
      <h4>1.市盈率(动)</h4>
      <p>总市值除以预估全年净利润，例如当前公布一季度净利润1000万，则预估全年净率润4000万</p>
      <h4>2.市盈率(静)</h4>
      <p>总市值除以年度净利润</p>
      <h4>3.市盈率(TTM)</h4>
      <p>最新价除以最近4个季度的每股收益</p>
  </div>
  )
}

export function PanKouIcon(){
  const [tipsVisible,setTipsVisible] = useState(false)

  const openTips = ()=>{
    setTipsVisible(true)
  }

  return (
    <>
      <span className="pk-icon" onClick={openTips}>?</span>
      {tipsVisible && <>
        <PanKouTips/>
        <PkTipsMask onClose={()=>setTipsVisible(false)}/>
      </>}
    </>
  )
}
